const languageRegex = new RegExp(/\/(en|de|it)\/?/i);

export default () => {
  const picker = document.getElementById("language-picker");
  picker?.addEventListener("change", e => {
    const target = e.target as HTMLSelectElement;
    const language = target.value;

    if (window.location.pathname === "/") {
      window.location.href = `/${language}`;
    } else {
      const newPath = window.location.pathname.replace(
        languageRegex,
        `/${language}/`,
      );

      window.location.href = newPath;
    }
  });
};
